import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { SyncSeatingOrderReducer } from '../../reducers/docs/syncSeatingOrder/types'

/** Orders the participants in the seating order and then returns the users' data in that order */
const getSeatingOrder = (state: State): SyncSeatingOrderReducer['seatingOrder'] => state.syncSeatingOrder.seatingOrder

export default createSelector<State, any, string[]>(
  [getSeatingOrder],
  (seatingOrder: SyncSeatingOrderReducer['seatingOrder']): string[] => {

    return Array.from(Object.entries(seatingOrder))
      .filter(([ , values ]) => values.seatedDatetime !== null && (values.presenterStatus === 'connected' || values.dialInStatus === 'connected'))
      .sort(function ([ , { seatedDatetime: seatedDatetimeA } ], [ , { seatedDatetime: seatedDatetimeB } ]) {

        if (seatedDatetimeA === null || seatedDatetimeB === null) return 0
        return (seatedDatetimeA < seatedDatetimeB) ? -1 : ((seatedDatetimeA > seatedDatetimeB) ? 1 : 0)

      })
      .map(([ BTID ]) => BTID)

  })
